import { DefaultConfig } from '../../features/ui-config'

/**
 * Recursively extracts paths to required form fields from the config.
 *
 * @param {DefaultConfig[keyof DefaultConfig]} config - The config object to traverse.
 * @returns {string[]} An array of strings representing paths to required fields.
 */
export function getRequiredFieldPathsFromConfig(
  config: DefaultConfig[keyof DefaultConfig],
) {
  const requiredFieldPaths: string[] = []
  let currentPath = ''

  function traverse(currentObj: any) {
    for (const fieldKey in currentObj) {
      const field = currentObj[fieldKey]

      const newPath = currentPath ? `${currentPath}.${fieldKey}` : fieldKey

      // Fields that are not required:
      // - Disabled fields are not visible so they are not required
      // - Readonly fields are not editable so they are not required
      // - Fields in some dialog are not needed to be filled out
      const isDisabled = field.enabled === false
      const isReadOnly = field.readonly === true
      const isNotNeededDialog =
        // orderResponse
        fieldKey === 'rejectOrder' ||
        fieldKey === 'rejectOrderItem' ||
        // despatchAdvice
        fieldKey === 'rejectDespatchAdvice' ||
        fieldKey === 'rejectDespatchAdviceItem' ||
        // invoice
        fieldKey === 'rejectAllowanceCharges' ||
        fieldKey === 'addAllowanceCharge' ||
        fieldKey === 'editAllowanceCharge' ||
        fieldKey === 'rejectInvoiceItemAllowanceCharges' ||
        fieldKey === 'addInvoiceItemAllowanceCharge' ||
        fieldKey === 'editInvoiceItemAllowanceCharge' ||
        fieldKey === 'addTermsOfPayment' ||
        fieldKey === 'editTermsOfPayment' ||
        fieldKey === 'rejectInvoice' ||
        // deliveryCallOff
        fieldKey === 'editSplitItem' ||
        fieldKey === 'addSplitItem' ||
        // deliveryForecastDespatchAdvice
        fieldKey === 'addConfirmationBatch' ||
        fieldKey === 'addPackaging' ||
        fieldKey === 'addPackagingItem' ||
        fieldKey === 'editPackagingItem' ||
        // field keys that are used in more places
        fieldKey === 'uploadAttachment' // despatchAdvice & invoice

      if (isDisabled || isReadOnly || isNotNeededDialog) {
        continue
      }

      // If the field has key "isRequired" push its path in requiredFieldPaths
      const isRequired = field.validation?.isRequired === true

      if (isRequired) {
        requiredFieldPaths.push(newPath)
      }

      if (field instanceof Object) {
        const previousPath = currentPath
        currentPath = newPath
        traverse(field)
        currentPath = previousPath // Reset to the previous path
      }
    }
  }

  traverse(config)

  return requiredFieldPaths
}
